/* dependencies */
import { NgModule, } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { environment } from '../environments/environment';


/* core app files */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

/* Materialize components */
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';

/* display components */
import { HeaderComponent } from './components/nav/header/header.component';
import { SideNavComponent } from './components/nav/side-nav/side-nav.component';
import { NavItemsComponent } from './components/nav/nav-items/nav-items.component';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchComponent } from './components/search/search.component';
import { SearchFiltersComponent } from './components/search/search-filters/search-filters.component';
import { SearchResultsComponent } from './components/search/search-results/search-results.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LoginComponent } from './components/user/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';

/* directives */
import { RestrictNumberInputDirective } from './common/directives/restrict-number-input.directive';

/* prism */
import Prism from 'prismjs';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/components/prism-markup-templating';

import 'prismjs/components/prism-json';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-python';
import 'prismjs/components/prism-go';
import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-csharp';

/* APL Dependencies */
import {AplUiFormRadioCardComponent} from '@anddone/apl-ui-form';


// Make Prism globally accessible
(window as any).Prism = Prism;

@NgModule({ 
    declarations: [
        AppComponent,
        HeaderComponent,
        SideNavComponent,
        SearchComponent,
        SearchFiltersComponent,
        SearchResultsComponent,
        NotFoundComponent,
        LoginComponent,
        RestrictNumberInputDirective,
        LayoutComponent,
        NavItemsComponent,
        
    ],
    bootstrap: [AppComponent], 
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        MatSidenavModule,
        MatSlideToggleModule,
        MatIconModule,
        NgbAccordionModule,
        FormsModule,
        ReactiveFormsModule,
        AplUiFormRadioCardComponent,
    ], providers: [
        {
            provide: APP_BASE_HREF,
            useValue: '/'
        },
        provideAnimationsAsync(),
        provideHttpClient(withInterceptorsFromDi()),
    ]
 })
export class AppModule { }
